import {
  RequestTimeOffResponse as Response,
  TimeOffEvent,
  UpdateTimeOffParams,
  convertTimeOffEvent,
} from '@nextforce/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

type Variables = UpdateTimeOffParams

export function useUpdateTimeOffRequest() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationFn: updateTimeOffRequest,
    onSuccess: async () => {
      client.invalidateQueries({ queryKey: keys.all }).catch(null)
    },
  })

  async function updateTimeOffRequest(
    updateParams: Variables
  ): Promise<TimeOffEvent> {
    const response = await server.put<Response.TimeOffEvent>(
      `/v2/time_off/${updateParams.id}`,
      {
        id: updateParams.id,
        user_id: updateParams.user_id,
        store_id: updateParams.store_id,
        start_time: updateParams.start_time,
        end_time: updateParams.end_time,
        reason: updateParams.reason,
        deleted: updateParams.deleted,
      }
    )

    return convertTimeOffEvent(response)
  }
}
